<template>
    <div>
        <b-card :title="$t('miniCurriculum.carrerInTheMarket')">
            <b-row>
                <b-col md="12" xl="12" sm="12">
                    <b-button
                        v-if="isCurrentUserOrAdminOrLocalAdmin"
                        class="mb-4 float-right"
                        variant="primary"
                        size="sm"
                        @click="onClickNewCareerInTheMarket"
                    >
                        {{
                            $t(
                                'miniCurriculum.form.buttons.addCareerInTheMarket'
                            )
                        }}
                    </b-button>
                </b-col>
            </b-row>

            <template v-if="!careerInTheMarket.length && isHidden">
                <b-alert show variant="info">
                    {{ $t('miniCurriculum.form.careerInTheMarketNotFound') }}
                </b-alert>
            </template>

            <div v-for="obj in careerInTheMarket" :key="obj.id">
                <b-row>
                    <b-col md="4" xl="4" sm="4">
                        <label for="office">{{
                            $t('miniCurriculum.form.label.office')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            ref="office"
                            :value="obj.office || '-'"
                            disabled
                        />
                    </b-col>

                    <b-col md="4" xl="4" sm="4">
                        <b-form-group
                            :label="`${$t('miniCurriculum.form.label.start')}`"
                            label-for="input-start-date"
                        >
                            <b-form-input
                                class="mb-2"
                                id="input-start-date"
                                disabled
                                :value="obj.start || '-'"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="4" xl="4" sm="4">
                        <b-form-group
                            :label="`${$t('miniCurriculum.form.label.end')}`"
                            label-for="input-end-date"
                        >
                            <b-form-input
                                class="mb-2"
                                id="input-end-date"
                                disabled
                                :value="isEndDate(obj.end)"
                            />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="6" sm="6">
                        <label for="companyName">{{
                            $t('miniCurriculum.form.label.companyName')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            :value="obj.company_name || '-'"
                            disabled
                        />
                    </b-col>

                    <b-col md="6" xl="6" sm="6">
                        <label for="area">{{
                            $t('miniCurriculum.form.label.area')
                        }}</label>
                        <b-form-input
                            class="mb-2"
                            :value="obj.area || '-'"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row>
                    <b-col>
                        <label for="main-activities">{{
                            $t('miniCurriculum.form.label.mainActivities')
                        }}</label>
                        <b-form-textarea
                            class="mb-3"
                            id="textarea"
                            rows="4"
                            max-rows="4"
                            :value="obj.main_activities || '-'"
                            disabled
                        ></b-form-textarea>
                    </b-col>
                </b-row>

                <b-media right-align vertical-align="center">
                    <div slot="aside">
                        <b-dropdown
                            v-if="isCurrentUserOrAdminOrLocalAdmin"
                            :no-caret="true"
                            :dropleft="true"
                            :text="$t('form.button.edit')"
                            variant="outline-primary btn-outline-primary"
                            size="sm"
                            class="ml-1"
                        >
                            <b-dropdown-item
                                @click="onClickEditCareerInTheMarket(obj.id)"
                            >
                                {{ $t('form.button.edit') }}
                            </b-dropdown-item>
                            <b-dropdown-item @click="handleDelete(obj.id)">
                                {{ $t('form.button.delete') }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </b-media>
            </div>
        </b-card>
    </div>
</template>

<script>
import api from '@/services/api'
import Swal from 'sweetalert2'
import i18n from '@/i18n'
import notification, { success } from '@/lib/notification'
import { formatDate } from '@/lib/date'

notification.init()

export default {
    name: 'CareerInTheMarketFormView',
    props: ['isCurrentUserOrAdminOrLocalAdmin', 'userId'],
    data() {
        return {
            careerInTheMarket: {},
            isHidden: false,
        }
    },
    mounted() {
        this.getCareerInTheMarket()
    },
    methods: {
        getCareerInTheMarket() {
            api.get(`users/${this.userId}/profile/career-in-the-market`)
                .then(resp => {
                    const {
                        data: { data },
                    } = resp
                    this.careerInTheMarket = data

                    this.careerInTheMarket.map((resp, index) => {
                        this.careerInTheMarket[index].start = formatDate(
                            resp.start,
                            'DD/MM/YYYY'
                        )
                        this.careerInTheMarket[index].end = formatDate(
                            resp.end,
                            'DD/MM/YYYY'
                        )
                    })
                })
                .finally(() => {
                    this.isHidden = true
                    this.$emit('ready')
                })
        },
        onClickNewCareerInTheMarket() {
            return this.$router.push(
                '/v2/mini-curriculum/career-in-the-market/new'
            )
        },
        onClickEditCareerInTheMarket(id) {
            return this.$router.push(
                `/v2/mini-curriculum/career-in-the-market/${id}/edit`
            )
        },
        handleDelete(id) {
            Swal({
                type: 'warning',
                title: i18n.t('notification.areYouSure'),
                confirmButtonText: i18n.t('notification.yes'),
                cancelButtonText: i18n.t('notification.no'),
                showCancelButton: true,
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    api.delete(`/career-in-the-market/${id}`).then(() => {
                        success(
                            i18n.t('notification.deletedSuccessfully', {
                                item: i18n.t(
                                    'miniCurriculum.carrerInTheMarket'
                                ),
                            })
                        )
                        this.getCareerInTheMarket()
                    })
                },
            })
        },
        isEndDate(endDate) {
            const dateReg = /^\d{2}[./-]\d{2}[./-]\d{4}$/
            return !endDate.match(dateReg) ? '-' : endDate
        },
    },
}
</script>
